<template>
  <TableList
    v-rect-loading="loading"
    row-key="id"
    class="custom-job-filter-list"
    :title="$t(`${i18nPrefix}.title`)"
    :listData="jobFilterList"
    :tableColumns="tableColumns"
    @dragSort="dragSort"
    @create="handleCreateJobFilter"
    @action="handleEditJobFilter"
  >
    <template #status="{ data, row }">
      <el-switch :value="data === 1" @change="onStatusChange($event, row)"></el-switch>
    </template>
    <template #required="{ data, row }">
      <el-switch :value="data" @change="onRequiredChange($event, row)"></el-switch>
    </template>
    <template #draggable>
      <div class="drag-btn">
        <i class="iconfont iconMore draggable-handle"></i>
      </div>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import { CUSTOM_FIELD_TYPE } from '@/constant/job'

export default {
  components: {
    TableList
  },
  props: {

  },
  data () {
    return {
      CUSTOM_FIELD_TYPE,
      loading: true,
      i18nPrefix: 'admin.company.customJobFilter',
      jobFilterList: []
    }
  },
  computed: {
    type () {
      return {
        [this.CUSTOM_FIELD_TYPE.SELECT]: this.$t(`${this.i18nPrefix}.label.select`),
        [this.CUSTOM_FIELD_TYPE.TEXT]: this.$t(`${this.i18nPrefix}.label.text`),
        [this.CUSTOM_FIELD_TYPE.SINGLE]: this.$t(`${this.i18nPrefix}.label.single`),
        [this.CUSTOM_FIELD_TYPE.TEXTAREA]: this.$t(`${this.i18nPrefix}.label.textarea`),
        [this.CUSTOM_FIELD_TYPE.DATE]: this.$t(`${this.i18nPrefix}.label.date`)
      }
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.cnName`),
          dataKey: 'cn_name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.enName`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.type`),
          dataKey: 'type',
          formatter: (data, row) => {
            return this.type[data]
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'status',
          slotName: 'status'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.required`),
          dataKey: 'is_required',
          slotName: 'required'
        },
        {
          label: this.$t('common.label.sortOperate'),
          isDragSort: true,
          slotName: 'draggable',
          width: 50
        }
      ]
      return columns
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('company', ['getJobFilterList', 'updateJobFilter', 'moveJobFilter']),
    async initData () {
      this.loadJobListFilter()
    },
    async loadJobListFilter () {
      this.loading = true
      try {
        const params = {
          need_inherit: false
        }
        const resp = await this.getJobFilterList(params)
        if (resp) {
          _.forEach(resp, jobFilter => {
            addI18nProperty(jobFilter, 'i18Name', 'cn_name', 'name')
          })
          this.jobFilterList = resp
        }
      } finally {
        this.loading = false
      }
    },
    handleCreateJobFilter () {
      this.$router.push('/v-admin/custom-job-filter/management/add')
    },
    handleEditJobFilter (row) {
      this.$router.push(`/v-admin/custom-job-filter/management/edit/${row.id}`)
    },
    async dragSort (newIndex, oldIndex) {
      if (newIndex === oldIndex) {
        return
      }
      const order = _.map(this.jobFilterList, jobFilter => jobFilter.id)
      const data = {
        filter_ids: order
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.moveJobFilter(data)
        if (resp && resp === 'success') {
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async onStatusChange (status, row) {
      const newStatus = status ? 1 : 0
      const data = {
        filterId: row.id,
        data: {
          status: newStatus
        }
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateJobFilter(data)
        if (resp) {
          row.status = newStatus
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async onRequiredChange (required, row) {
      const newRequired = required ? 1 : 0
      const data = {
        filterId: row.id,
        data: {
          required: newRequired
        }
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateJobFilter(data)
        if (resp) {
          row.is_required = newRequired === 1
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-job-filter-list {
  .drag-btn {
    .draggable-handle {
      cursor: pointer;
    }
  }
}
</style>
